import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { DashboardContext, ToasterContext, UserContext } from '../../../context';
import { default as t } from '../../../utils/i18n';
import '../optimisation-container/optimisation-container.scss';
import './choose-report-campaigns.scss';
import {
  AppTooltip,
  CheckBox,
  Checkpicker,
  DateRangepicker,
  Dropdown,
  SearchBar,
} from '../../atoms';
import { Button, DateRangePicker, Pagination, Popover, Tooltip, Whisper } from 'rsuite';
import { Label } from '@material-ui/icons';
import { DashService, ReportsService } from '../../../services';
import { ModalWindow, ActionLink, CommonToaster } from '../../atoms';

import { Table, Checkbox } from 'rsuite';
import { postTrackUsageAPI, updateReport } from '../../../services/dash.service';
import { createPostTrackUsagePayload, UsageIdentifierFlow } from '../../../utils/misc';

const { allowedMaxDays, allowedDays, allowedRange, beforeToday, afterToday, combine } =
  DateRangePicker;

const ChooseReportCampaigns = ({
  activeStep,
  setActiveStep,
  stepperData,
  setStepperData,
  draftReportId,
}) => {
  const history = useHistory();
  const { dashData } = useContext(DashboardContext);
  const { user, setUser } = useContext(UserContext);
  const { message, setMessage } = useContext(ToasterContext);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const { Column, HeaderCell, Cell } = Table;
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [selectedVals, setSelectedVals] = useState([
    { id: '0', value: t('report.client.reporting.select.campaign'), accountId: '' },
  ]);
  const [searchItem, setSearchItem] = useState('');
  const [show, showstyle] = useState('');
  const [filteredList, setfilteredList] = useState([]);
  const [businessManagers, setBusinessManagers] = useState([]);
  const [selectedBM, setSelectedBM] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateRangeValue, setDateRangeValue] = useState();
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAdAccount, setSelectedAdAccount] = useState('');
  const [sortColumn, setSortColumn] = useState();
  const [sortType, setSortType] = useState();
  const [loading, setLoading] = useState(false);
  const [importSelected, setImportSelected] = useState([]);

  const [objectives, setObjectives] = useState([]);
  const [objectiveSelected, setObjectiveSelected] = useState([]);
  const [objectivecheckedArr, setObjectivecheckedArr] = useState([]);

  const [disabledButton, setDisabledButton] = useState(true);

  const [currency, setCurrency] = useState('');
  const [data, setData] = useState([]);
  const authenticated = user?.authenticated;

  const [selectedAdverse, setSelectedAdverse] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [filterBy, setFilterBy] = useState(null);
  const [advertisersList, setAdvertisersList] = useState([]);
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [isBackClicked, setIsBackClicked] = useState(false);
  const [existinData, setExistingData] = useState({});
  const reportId = draftReportId ? draftReportId : stepperData?.data?.data?.reportId;
  const [toaster, setToaster] = useState(false);

  let checked = false;
  let indeterminate = false;

  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  useEffect(() => {
    if (reportId) {
      getReportResponse();
    } else {
      getAllAdvertiser();
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setfilteredList(data);
    if (draftReportId && user?.isSaveDraft) {
      let msg = t('mgs.success.saveStep');
      setTheMessages({ message: msg, isError: false });
    }
  }, []);

  useEffect(() => {
    if (objectiveSelected.length > 0) {
      setfilteredList(data);
      objectiveFilterHandler(objectiveSelected);
    } else {
      showstyle('');
      setfilteredList(data);
    }
  }, [objectiveSelected]);

  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });

  async function getReportResponse() {
    try {
      const reportRes = await ReportsService.getReportDetails(userAccessToken, username, reportId);
      let resultedReportResponse = reportRes?.data?.data;
      setExistingData({ ...resultedReportResponse });
      setStepperData(resultedReportResponse?.type?.toLowerCase());
      getAllAdvertiser(resultedReportResponse);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
  };

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }}>
      <div style={{ lineHeight: '46px' }} className={rowData.is_imported ? 'disabled' : null}>
        <Checkbox
          value={rowData[dataKey]}
          inline
          onChange={onChange}
          checked={checkedKeys.some(item => item === rowData[dataKey])}
        />
      </div>
    </Cell>
  );

  if (checkedKeys.length === filteredList?.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < filteredList.length) {
    indeterminate = true;
  }

  const updateDateFormatApi = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    // const date = d.getHours() + ':' + (d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes()) + " " + d.toLocaleDateString();
    return yyyy + '-' + mm + '-' + dd;
  };

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    // const date = d.getHours() + ':' + (d.getMinutes() < 10 ? ("0" + d.getMinutes()) : d.getMinutes()) + " " + d.toLocaleDateString();
    return dd + '-' + mm + '-' + yyyy;
  };

  const getDateRange = (startTime, stopTime) => {
    if (stopTime) {
      return updateDateFormat(startTime) + ' to ' + updateDateFormat(stopTime);
    } else {
      return updateDateFormat(startTime) + ' ' + 'onwards';
    }
  };

  const deleteItem = (id, list) => {
    const templist = [...list];
    const updateList = templist.filter(item => item.id !== id);
    const unchecked = checkedKeys.filter(keys => keys !== id);
    setSelectedVals(updateList);
    setCheckedKeys(unchecked);
    setImportSelected(unchecked);
    if (updateList.length === 0) {
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setImportSelected([]);
      setDisabledButton(true);
    }
  };

  const addItems = (keys, campaignList) => {
    let newData = campaignList?.length ? campaignList : data;
    let newList = newData?.filter(item => keys.includes(item.id));
    let checkedItem = newList.map(item => {
      return {
        id: item.id,
        value: item.name,
        accountId: item.account_id,
        campaignName: item.name,
        accountName: item.accountName,
        objective: item.objective,
      };
    });
    let checkedList = [];
    checkedList.push(checkedItem);
    setSelectedVals(checkedList[0]);
  };

  const handleCheckAll = (value, checked) => {
    let keys = checked ? filteredList.map(item => item.id) : [];
    if (!checked) {
      let notToUncheck = filteredList.filter(x => x.is_imported === true).map(y => y.id);
      setCheckedKeys(notToUncheck);
    } else {
      setCheckedKeys(keys);
    }
    addItems(keys);
    setImportSelected(keys);
    if (keys.length > 0) {
      setDisabledButton(false);
    } else {
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setDisabledButton(true);
    }
  };

  const handleCheck = (value, checked) => {
    let keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
    setCheckedKeys([...keys]);
    addItems([...keys]);
    setImportSelected([...keys]);
    if (keys.length > 0) {
      setDisabledButton(false);
    } else {
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setDisabledButton(true);
    }
  };

  const filterHandler = keyword => {
    if (!keyword.trim()) {
      showstyle('');
      setSearchItem('');
      setfilteredList(data);
    } else {
      showstyle('show');
      setSearchItem(keyword);
      // let res = data.filter(item => item.name.toLowerCase().includes(keyword.toLowerCase()));
      setPage(1);
      let res = data.filter(function (obj) {
        return (
          obj.name.toLowerCase().includes(keyword.toLowerCase()) ||
          obj.accountName.toLowerCase().includes(keyword) ||
          obj.objective.toLowerCase().includes(keyword.toLowerCase())
        );
      });
      setfilteredList(res);
    }
  };

  const objectiveFilterHandler = keyword => {
    showstyle('show');
    let temp = data;
    let tempArry = [];
    temp.forEach(res => {
      keyword?.forEach(val => {
        if (res?.objective?.toLowerCase() === val?.value?.toLowerCase()) {
          tempArry.push(res);
        }
      });
    });
    setfilteredList(tempArry);
  };

  const getAllAdvertiser = async exisData => {
    try {
      const response = await DashService.advertiserList(userAccessToken, username);
      let adverseList = response.data?.data?.map((advertiser, index) => ({
        value: advertiser,
        label: advertiser,
      }));
      setAdvertisersList(adverseList);
      const index = adverseList.findIndex(li => li?.value == exisData?.advertiser);
      if (index > -1) {
        setSelectedAdverse(adverseList[index]);
        getAdAccounts(exisData, adverseList[index]);
      }
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };

  const getAdAccounts = async (exisData, selectedOption, selectFromContext = true) => {
    try {
      const adAcResponse = await DashService.getAdAccountsForAdvertisers(
        userAccessToken,
        username,
        selectedOption?.value
      );
      let adAccountList = adAcResponse.data?.data?.map(adAccounts => ({
        value: adAccounts.id,
        label: adAccounts.name,
      }));
      let addedActIds = [];
      if (exisData?.campaigns?.length) {
        exisData?.campaigns?.forEach(campaign => {
          addedActIds.push(campaign?.accountId);
        });
        const unique = [...new Set(addedActIds)];
        let prevSelected = [];
        unique?.forEach(id => {
          const index = adAccountList?.findIndex(li => li?.value === id);
          if (index > -1) {
            prevSelected.push(adAccountList[index]?.value);
          }
        });
        setSelectedAdAccount([...prevSelected]);
        const val = [new Date(exisData?.startDate), new Date(exisData?.endDate)];
        handleDateRange(val, prevSelected, exisData);
      }
      setAdAccounts([...adAccountList]);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };

  async function getCampaigns(startDate, endDate, selectedAdAccount, editData) {
    if (startDate && endDate && selectedAdAccount.length > 0) {
      let campaignType = editData?.type
        ? editData?.type?.toLowerCase() === 'live'
          ? editData?.type?.toLowerCase()
          : 'completed'
        : stepperData.toLowerCase() === 'live'
        ? stepperData?.toLowerCase()
        : 'completed';
      const query =
        'type=' +
        campaignType +
        '&adAccounts=' +
        selectedAdAccount.toString() +
        '&startDate=' +
        startDate +
        '&endDate=' +
        endDate;
      setData([]);
      setfilteredList([]);
      setObjectives([]);
      setCheckedKeys([]);
      setToaster(false);
      setMessage([]);
      try {
        const campaignsResponse = await DashService.getCampaignsList(
          userAccessToken,
          username,
          query
        );
        let checkedKeys = [];
        let objective = [];
        let campaignsList = await campaignsResponse.data?.data?.campaigns?.map(
          campaignsResponse => ({
            id: campaignsResponse?.id,
            name: campaignsResponse?.name,
            date: getDateRange(campaignsResponse['start_time'], campaignsResponse['stop_time']),
            account_id: 'act_' + campaignsResponse?.account_id,
            accountName: campaignsResponse?.accountName,
            objective: campaignsResponse?.objective,
            start_date: campaignsResponse['start_time'],
          })
        );
        objective = [...new Set(campaignsList.map(x => x.objective))];
        setObjectives(objective);
        setCheckedKeys(checkedKeys);
        let campaignIds = [];
        if (editData?.campaigns?.length) {
          editData?.campaigns?.forEach(campaign => {
            campaignIds?.push(campaign?.id);
          });
          if (campaignIds?.length > 0) {
            setCheckedKeys([...campaignIds]);
            addItems([...campaignIds], campaignsList);
            setImportSelected([...campaignIds]);
            if (campaignIds.length > 0) {
              setDisabledButton(false);
            } else {
              setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
              setDisabledButton(true);
            }
          }
        }
        setData(campaignsList);
        setfilteredList(campaignsList);
      } catch (error) {
        let msg = '';
        if (error && error !== null) {
          if (error.status === 504 || error.status === 408) {
            msg = error?.data?.message_code ? t(error?.data.message_code) : t('error.mgs.504');
            setTheMessages({ message: msg, isError: true, isFixed: true });
          } else {
            msg = t(error?.data?.data?.message);
            setTheMessages({ message: msg, isError: true });
          }
        }
      }
    }
  }

  async function createReport(compaignsData) {
    try {
      const createReportRes = await ReportsService.createReport(
        userAccessToken,
        username,
        compaignsData
      );
      setStepperData(createReportRes);
      setUser(prevUser => ({
        ...user,
        draftReportId: createReportRes?.data?.data?.reportId,
        isSaveDraft: true,
        isFirstTimeCreation: true,
      }));
      setActiveStep(activeStep + 1);
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  }

  const handleOnSelectAdverse = selectedOption => {
    setSelectedAdverse(selectedOption);
    setSelectedAdAccount('');
    setAdAccounts([]);
    setSelectedAdAccount([]);
    setDateRangeValue(null);
    setStartDate('');
    setEndDate('');
    setObjectives([]);
    setObjectiveSelected([]);
    setObjectivecheckedArr([]);
    setCheckedKeys([]);
    setData([]);
    setfilteredList([]);
    setSelectedVals([]);
    setDisabledButton(true);
    getAdAccounts('', selectedOption, false);
  };

  const handleOnSelectAdAccount = selectedOption => {
    if (selectedOption.length > 0) {
      setSelectedAdAccount(selectedOption);
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setImportSelected([]);
      setDisabledButton(true);
      getCampaigns(startDate, endDate, selectedOption);
    } else {
      setSelectedAdAccount(selectedOption);
      setDateRangeValue(null);
      setStartDate('');
      setEndDate('');
      setObjectives([]);
      setObjectiveSelected([]);
      setObjectivecheckedArr([]);
      setCheckedKeys([]);
      setData([]);
      setfilteredList([]);
      setSelectedVals([]);
      setDisabledButton(true);
    }
  };

  const handleDateRange = async (value, exisData, editData) => {
    setStartDate('');
    setEndDate('');
    if (value !== null) {
      const startDate = updateDateFormatApi(value[0]);
      const endDate = updateDateFormatApi(value[1]);
      setStartDate(updateDateFormatApi(value[0]));
      setEndDate(updateDateFormatApi(value[1]));
      setDateRangeValue(value);
      setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
      setImportSelected([]);
      const selAdAcc = exisData?.length ? exisData : selectedAdAccount;
      getCampaigns(startDate, endDate, selAdAcc, editData);

      setUser(prevUserState => ({
        ...prevUserState,
        dropdowns: {
          adaccount: selectedAdAccount,
        },
      }));
    } else {
      setDateRangeValue(null);
      setObjectives([]);
      setObjectiveSelected([]);
      setObjectivecheckedArr([]);
      setCheckedKeys([]);
      setData([]);
      setfilteredList([]);
      setSelectedVals([]);
      setDisabledButton(true);
    }
  };

  const getData = () => {
    if (sortColumn && sortType) {
      filteredList.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (sortColumn === 'date') {
          const initialDate = new Date(a.start_date);
          const nextDate = new Date(b.start_date);
          return sortType === 'asc' ? initialDate - nextDate : nextDate - initialDate;
        } else {
          return sortType === 'asc' ? x.localeCompare(y) : y.localeCompare(x);
        }
      });
    }
    return filteredList.filter((v, i) => {
      const start = limit * (page - 1);
      const end = start + limit;
      return i >= start && i < end;
    });
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  async function handleOnImportCampaigns() {
    try {
      let importSelectedResponse;
      let diff = -1;
      let data = {
        accountId: selectedAdAccount.value,
        campaigns: importSelected,
      };
      importSelectedResponse = await DashService.importSelected(userAccessToken, username, data);
      diff = importSelected?.length - importSelectedResponse?.data?.data?.importSuccessfull?.length;

      if (diff === 0) {
        setMessage({ message: t('import.success'), isError: false });
        history.push('/optimization');
      } else if (diff > 0 && !importSelected.length) {
        let msg =
          'Only' +
          diff +
          'out of your' +
          importSelected?.length +
          'campaigns could be imported due to a server error. Please retry again later.';
        setMessage({ message: msg, isError: true });
        history.push('/optimization');
      } else {
        setMessage({ message: t('import.server.error'), isError: true });
        history.push('/optimization');
      }
    } catch (error) {
      setMessage({ message: t('import.server.error'), isError: true });
      history.push('/optimization');
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
      }
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const nFormatter = (num, digits) => {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'K' },
    ];

    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
      .slice()
      .reverse()
      .find(item => {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol : '0';
  };

  const TableCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Table.Cell
        {...props}
        title={rowData[dataKey]}
        className={dataKey === 'name' ? 'campaign-column' : null}
      >
        {rowData[dataKey]}
      </Table.Cell>
    );
  };

  const getWidth = (value = 10) => {
    return window.innerWidth / value;
  };

  const handleSearchOnChange = () => {};
  const handleDropdownOnChange = () => {};

  const handleOnSelectBM = selectedOption => {
    // setDropdownDisabledButton(false);
    setSelectedBM(selectedOption);
    // setisAdAccountDisabled(true);
    getAdAccounts('', selectedOption.value);
    setSelectedVals([{ id: '0', value: t('report.client.reporting.select.campaign') }]);
    setImportSelected([]);
    setDisabledButton(true);
  };

  const handleChange = (event, newValue) => {};
  const updateCount = (count, type) => {};

  const callTrackUsageAPI = () => {
    if (selectedAdAccount.length) {
      const localStorageUserObj = localStorage.getItem('user');
      const { usageAPIPayload, updatedLocalStorageUserValue } = createPostTrackUsagePayload(
        selectedAdAccount,
        JSON.parse(localStorageUserObj),
        UsageIdentifierFlow.AD_ACCOUNT
      );

      if (usageAPIPayload.ids.length) {
        postTrackUsageAPI(userAccessToken, username, {
          ...usageAPIPayload,
          userFlow: `define-report`,
        });
      }
      localStorage.setItem('user', JSON.stringify(updatedLocalStorageUserValue));
      setUser(updatedLocalStorageUserValue);
    }
  };

  const handleClick = () => {
    let createReportRequest = {};
    callTrackUsageAPI();
    if (user?.reportName) {
      createReportRequest = {
        type: stepperData,
        startDate: startDate,
        endDate: endDate,
        advertiser: selectedAdverse.value,
        campaigns: selectedVals,
        reportName: user?.reportName,
      };
    } else {
      createReportRequest = {
        type: stepperData,
        startDate: startDate,
        endDate: endDate,
        advertiser: selectedAdverse.value,
        campaigns: selectedVals,
      };
    }
    if (existinData?.reportId) {
      updateReport(createReportRequest, existinData?.reportId);
    } else {
      createReport(createReportRequest);
    }
  };

  const updateReport = async (payload, reportId) => {
    try {
      const reportResponse = await ReportsService.updateReportDetails(
        userAccessToken,
        username,
        payload,
        reportId
      );
      let responseDetails = reportResponse?.data?.data;
      setStepperData(reportResponse);
      setUser(prevUser => ({
        ...user,
        isSaveDraft: true,
      }));
      setActiveStep(activeStep + 1);
    } catch (error) {
      let msg = '';
      if (error && error !== null) {
        msg = t(error?.data?.data?.message);
        setTheMessages({ message: msg, isError: true });
      }
    }
  };

  const handleBack = () => {
    setIsBackClicked(true);
    setShowCancelModal(true);
  };

  const handleCancel = () => {};

  const handleCancelClick = e => {
    e.preventDefault();
    setIsBackClicked(false);
    setShowCancelModal(true);
  };

  const handleOnCloseCancelModal = () => {
    setIsBackClicked(false);
    setShowCancelModal(false);
  };

  const onContinue = e => {
    e.preventDefault();
    setShowCancelModal(false);
    if (isBackClicked) {
      setActiveStep(activeStep - 1);
    } else {
      history.push('/reports');
    }
  };

  const onCancelReq = () => {
    setShowCancelModal(false);
  };

  const setTheMessages = message => {
    if (message?.message) {
      setToaster(true);
      setMessage([]);
      setMessage(message);
      if (!message?.isFixed) {
        clearToaster();
      }
    }
  };

  const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
    }, 7000);
  };

  return (
    <div className="choose-report">
      <div className={toaster ? 'toasterTop' : ''}>
        <CommonToaster message={message} toaster={toaster}></CommonToaster>
      </div>
      <div className="exit">
        <button className="step-cancel" disabled={activeStep === 0} onClick={handleCancelClick}>
          {t('report.client.reporting.exit')}
        </button>
      </div>
      <div className="choose-report">
        <h3>{t('define.choose.campaign.header')}</h3>
        <div className="filter-section">
          <div className="left-section">
            <div className="advertiser" style={{ width: getWidth(5) }}>
              {/* <label>{t('advertiser')}</label> */}
              <Dropdown
                className="user-select"
                heading={t('reportTable.text.advertiser')}
                value={selectedAdverse}
                options={advertisersList}
                onSelect={handleOnSelectAdverse}
                placeholder={t('create.report.share.modal.placeholder3')}
                tooltipIndicator={true}
                tooltipId={t('business-manager')}
                infoData={t('define.choose.campaign.advertiser.tooltip')}
                isImportant={true}
              />
            </div>
            <div className="ad-account" style={{ width: getWidth(4) }}>
              {/* <label>{t('Ad account')}</label> */}
              <Checkpicker
                // className="ad-account"
                heading={t('define.stepper.adAccount')}
                value={selectedAdAccount}
                options={adAccounts}
                onSelect={handleOnSelectAdAccount}
                placeholder={t('define.stepper.adAccount.placeholder')}
                tooltipIndicator={true}
                searchIndicator={true}
                tooltipId={t('ad-account')}
                infoData={t('define.choose.campaign.ad-account.tooltip')}
                search={true}
                customIndicator={true}
                isImportant={true}
              />
            </div>
            <div className="Date-range-section" style={{ width: getWidth(4) }}>
              <DateRangepicker
                // className="ad-account"
                heading={t('define.stepper.dateRange')}
                value={dateRangeValue}
                onOk={date => handleDateRange(date)}
                placeholder1={t('define.stepper.dateRange.placeholder1')}
                placeholder2={t('define.stepper.dateRange.placeholder2')}
                tooltipIndicator={true}
                tooltipId={t('ad-account')}
                infoData={t('define.choose.campaign.date-range.tooltip')}
                format={'dd-MM-yyyy'}
                size={'lg'}
                placement={'bottomEnd'}
                type={user?.reportType?.toLowerCase()}
                isImportant={true}
              />
            </div>
          </div>
        </div>
        <div className="search-top">
          <div className="search-field">
            <i className="eva eva-search-outline search-icon"></i>
            <input
              type="text"
              name="search"
              placeholder={t('define.stepper.search.placeholder')}
              onChange={e => filterHandler(e.target.value, e)}
              value={searchItem}
              autoComplete="off"
            />
            <button type="button" className={`clear-btn ${show}`} onClick={e => filterHandler('')}>
              <i className="eva eva-close-outline clear-icon"></i>
            </button>
          </div>
        </div>
        <div className="list-scroll-container">
          <div className="list-scroll">
            <div className="selected-list">
              {selectedVals?.map(item => {
                return (
                  <div
                    className="selected-item"
                    key={item.id}
                    onClick={() => deleteItem(item.id, selectedVals)}
                  >
                    <span
                      className={
                        selectedVals[0].value === t('report.client.reporting.select.campaign')
                          ? 'selected-value selected-empty-value'
                          : 'selected-value'
                      }
                      title={item?.value}
                    >
                      {item.value?.length > 0 ? item?.value : item?.value}
                    </span>
                    {selectedVals[0].value === t('report.client.reporting.select.campaign') ? (
                      ''
                    ) : (
                      <span className="cross">
                        <i className="eva eva-close-outline clear-icon"></i>
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="import-campaign">
          <Table
            virtualized
            height={510}
            data={getData()}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            loading={loading}
            locale={{ emptyMessage: t('define.stepper.table.noDataFound') }}
          >
            <Column width={50} fixed align="center">
              <HeaderCell style={{ padding: 0 }}>
                <div style={{ lineHeight: '40px' }}>
                  <Checkbox
                    inline
                    checked={checked}
                    indeterminate={indeterminate}
                    onChange={handleCheckAll}
                    //  disabled={indeterminate ? indeterminate : checkedKeys.length === data.length }
                  />
                </div>
              </HeaderCell>
              <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
            </Column>
            <Column width={getWidth(6)} fixed sortable resizable>
              <HeaderCell>
                {t('define.stepper.table.campaignName')} <span className="imp-icon">*</span>
                <Whisper
                  placement="right"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>{t('define.stepper.table.campaignName.tooltip')}</Tooltip>}
                >
                  <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                </Whisper>
              </HeaderCell>
              <TableCell dataKey="name" />
            </Column>

            <Column width={getWidth(6)} fixed sortable resizable>
              <HeaderCell>
                {t('define.stepper.table.adAccount')}
                <Whisper
                  placement="bottom"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>{t('define.stepper.table.adAccount.tooltip')}</Tooltip>}
                >
                  <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                </Whisper>
              </HeaderCell>
              <TableCell dataKey="accountName" />
            </Column>

            <Column width={getWidth(5)} fixed sortable resizable>
              <HeaderCell>
                {t('define.stepper.table.dateRange')}
                <Whisper
                  placement="bottom"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>{t('define.stepper.table.dateRange.tooltip')}</Tooltip>}
                >
                  <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                </Whisper>
              </HeaderCell>
              <TableCell dataKey="date" />
            </Column>

            <Column width={getWidth(6)} fixed>
              <HeaderCell>
                {t('define.stepper.table.objective')}
                <Whisper
                  placement="bottomEnd"
                  trigger="click"
                  speaker={
                    <Popover>
                      <div className="objective-category">
                        <CheckBox
                          heading={t('define.stepper.table.objective')}
                          placeholder={t('define.stepper.table.objective.placeholder')}
                          tooltip={t('define.stepper.table.objective.tooltip')}
                          options={objectives}
                          list={objectiveSelected}
                          setList={setObjectiveSelected}
                          classname="advertiser"
                          selectedItem={objectivecheckedArr}
                          checkedArr={objectivecheckedArr}
                          setcheckedArr={setObjectivecheckedArr}
                        />
                      </div>
                    </Popover>
                  }
                >
                  <Button className="arrow-down">
                    <i className="eva eva-arrow-down"></i>
                  </Button>
                </Whisper>
                <Whisper
                  placement="left"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>{t('define.stepper.table.objective.tooltip')}</Tooltip>}
                >
                  <i className="eva eva-info-outline" data-for="tool-tip1"></i>
                </Whisper>
              </HeaderCell>
              <TableCell dataKey="objective" />
            </Column>
          </Table>
          <div className="pagination-div">
            <span>{t('define.stepper.table.rowsPerPage')}</span>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              layout={['-', 'limit', '|', 'pager']}
              total={filteredList.length}
              limitOptions={[10, 15]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
        <div className="btn-steps">
          <span
            className="step-back"
            data-tip={reportId ? t('define.stepper.campaign.back.tooltip') : ''}
            data-for="tool-tip3"
          >
            <button className="step-back" disabled={reportId} label="Back" onClick={handleBack}>
              {t('define.report.stepper.button.back')}
            </button>
          </span>
          <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip2" place="right" />
          <span
            className="step-next"
            data-tip={disabledButton ? t('define.stepper.campaign.next.tooltip') : ''}
            data-for="tool-tip3"
          >
            <button
              className="step-next"
              onClick={handleClick}
              disabled={disabledButton}
              label="Next"
            >
              {t('define.report.stepper.button.next')}
            </button>
          </span>
          <AppTooltip className="c-table-info-icon--tooltip" id="tool-tip3" place="left" />
        </div>

        <div className="report-delete">
          <ModalWindow
            className="fqa-modal--showanswer"
            isOpen={showCancelModal}
            onRequestClose={handleOnCloseCancelModal}
            heading={
              !isBackClicked ? t('define.stepper.cancel.heading') : t('define.stepper.back.heading')
            }
          >
            <p className="fqa-model-showanswer--message message-font">
              {!isBackClicked
                ? t('define.stepper.cancel.subHeading')
                : t('define.stepper.back.subHeading')}
            </p>
            <p></p>
            <div className="fqa-model-pa--actions">
              <ActionLink
                anchor={true}
                value={
                  !isBackClicked ? t('define.stepper.continue') : t('define.stepper.table.back')
                }
                handleClick={onContinue}
              />
              <button className="fqa-model-pa--actions-confirm delete-button" onClick={onCancelReq}>
                {t('define.stepper.cancel')}
              </button>
            </div>
          </ModalWindow>
        </div>
      </div>
    </div>
  );
};

export default ChooseReportCampaigns;
